export default __webpack_public_path__ + "static/media/Fire.03e09c34.svg";